import { render } from "./Project.vue?vue&type=template&id=72fac122&scoped=true"
import script from "./Project.vue?vue&type=script&lang=js"
export * from "./Project.vue?vue&type=script&lang=js"

import "./Project.vue?vue&type=style&index=0&id=72fac122&scoped=true&lang=css"

import exportComponent from "C:\\Users\\carlc\\portfolio\\portfolio-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72fac122"]])

export default __exports__